export enum EntityType {
  User = "User",
  UserGroup = "UserGroup",
  ApiKey = "ApiKey",
  Stack = "Stack",
}

export type EntityWithRoleBinding = {
  type: EntityType;
  id: string;
  name: string;
  roleBindingId: string;
  space: {
    id: string;
    name: string;
  };
  isLastRole: boolean;
};

export type CellComponentProps = {
  entity: EntityWithRoleBinding;
  roleName: string;
  readOnly?: boolean;
};
